import {
  ContactsOutlined,
  FileTextOutlined,
  HomeOutlined,
  ProductOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from '@tanstack/react-router';
import { Layout, Menu } from 'antd';
import { useEffect, useMemo, useState } from 'react';

import { MainContent } from './MainContent';

import { MainHeader } from '@/components/layout';
import { MainFooter } from '@/components/layout/MainFooter';
import { ROUTE_CONSTANTS } from '@/routes';
import { checkRoutePath, getImageUrl } from '@/shared/utils';

export function MainLayout() {
  const [currentRoute, setCurrentRoute] = useState(ROUTE_CONSTANTS.APPS_PATH);
  const location = useLocation();

  useEffect(() => {
    setCurrentRoute(checkRoutePath(location.pathname));
  }, [location.pathname]);

  const menuItems = useMemo(
    () => [
      {
        key: ROUTE_CONSTANTS.HOME_PATH,
        icon: <HomeOutlined />,
        label: <Link to={ROUTE_CONSTANTS.HOME_PATH}>Home</Link>,
      },
      {
        key: ROUTE_CONSTANTS.APPS_PATH,
        icon: <ProductOutlined />,
        label: <Link to={ROUTE_CONSTANTS.APPS_PATH}>Software</Link>,
      },
      {
        key: ROUTE_CONSTANTS.DOCUMENT_PATH,
        icon: <FileTextOutlined />,
        label: <Link to={ROUTE_CONSTANTS.DOCUMENT_PATH}>Dokumente</Link>,
      },
      {
        key: ROUTE_CONSTANTS.CONTACTS_PATH,
        icon: <ContactsOutlined />,
        label: <Link to={ROUTE_CONSTANTS.CONTACTS_PATH}>Kontakte</Link>,
      },
    ],
    []
  );

  return (
    <Layout style={{ height: '100vh', display: 'flex', flexDirection: 'row' }}>
      <Layout.Sider theme={'light'} collapsed={false}>
        <div style={{ height: 32, margin: 16 }}>
          <Link to='/' replace>
            <img src={getImageUrl('/images/mailalliance-logo.svg')} alt='mail alliance Logo' />
          </Link>
        </div>
        <Menu mode='inline' selectedKeys={[currentRoute]} items={menuItems} />
      </Layout.Sider>
      <Layout style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <MainHeader />
        <div
          style={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}
        >
          <MainContent />
        </div>
        <MainFooter />
      </Layout>
    </Layout>
  );
}
